import React from 'react';

const CertButton = ({ cert, title, selected, onClick }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, cursor: 'pointer' }} onClick={onClick}>
      <div className={`cert-button${selected ? " cert-selected" : ""}`}>
        <div className="cert-image">
          <img
            src={`/assets/${cert}.png`}
            alt={cert}
            width="35"
            height="35"
            style={{ borderRadius: '8px' }}
          />
        </div>
      </div>
      <span style={{ fontSize: 11, fontWeight: selected ? 600 : 400, color: selected ? '#3182F6' : '#8a95a0' }}>{title}</span>
    </div>
  );
};

export default CertButton;
